// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"221":"299609ca","411":"75cf4f39","555":"d6ae5c30","745":"7681f0d3","748":"886dbd1e","758":"526e8de6","930":"d0c74501","947":"dbd2e944"}[chunkId] + ".chunk.js";
};